<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { IProfile } from '@/interfaces';
import ParticipantsListOverlay from '@/overlays/ParticipantsListOverlay.vue';
import i18n from '@/utils/i18n';
import { computed, ref } from 'vue';

const showParticipantsOverlay = ref<boolean>(false);

interface Props {
  profiles: IProfile[];
  participantType: string;
  canTriggerOverlay?: boolean;
  borderBottom?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  canTriggerOverlay: false,
  borderBottom: true,
});

const title = computed(() => {
  return props.participantType === 'participant'
    ? i18n.global.t('global.participants', props.profiles.length)
    : i18n.global.t('global.responsible', props.profiles.length);
});
</script>

<template>
  <div>
    <BasicBlock
      :icon="['fal', 'user-friends']"
      :ariaDescription="title"
      :text="`${profiles.length} ${title}`"
      :can-trigger-overlay="canTriggerOverlay"
      :borderBottom="borderBottom"
      @click="showParticipantsOverlay = true"
    />

    <ParticipantsListOverlay
      v-if="showParticipantsOverlay"
      :title="title"
      :profiles="profiles"
      @close="showParticipantsOverlay = false"
    />
  </div>
</template>
